import { all, takeLatest, call, put, select } from 'redux-saga/effects';

import { requestContact, updatePlan } from '@api/account';
import { getAccount } from '@redux/ducks/global';
import { fetchData, getCurrentPlan } from '@redux/ducks/account/pricingPlan/pricingPlans';
import {
  SUBMIT_TO_BE_IN_TOUCH,
  toBeInTouchFailed,
  toBeInTouchSucceed,
  CONFIRM,
  showTerms,
  showLoadingSpinner,
  hideLoadingSpinner,
  confirmFailed,
  confirmSucceed,
  getState,
  resetError,
} from '@redux/ducks/account/pricingPlan/changePricingPlan';
import { getChangeType } from '@redux/ducks/account/pricingPlan/pricingPlans.utils';
import { ChangeType } from '@redux/ducks/account/pricingPlan/interfaces';

// Tasks

export function* submitToBeInTouchTask() {
  try {
    yield put(resetError());

    const { id: accountId } = yield select(getAccount);

    yield call(requestContact, accountId);

    yield put(toBeInTouchSucceed());
  } catch (_err) {
    yield put(toBeInTouchFailed());
  }
}

export function* confirmTask() {
  const { areTermsAccepted, isLoading, plan } = yield select(getState);

  if (isLoading) {
    return;
  }

  yield put(resetError());

  const currentPlan = yield select(getCurrentPlan);

  const currentNotYearly = (currentPlan && !currentPlan.yearly) || !currentPlan;
  const changeType = getChangeType(plan, currentPlan);

  const shouldTermsBeShown: boolean =
    !areTermsAccepted && changeType !== ChangeType.Downgrade && currentNotYearly && plan.yearly;

  if (shouldTermsBeShown) {
    yield put(showTerms());

    return;
  }

  try {
    yield put(showLoadingSpinner());

    const { id: accountId } = yield select(getAccount);

    yield call(updatePlan, accountId, plan.id, true);

    yield put(confirmSucceed());

    yield put(fetchData());
  } catch (err) {
    yield put(confirmFailed(err));
    yield put(hideLoadingSpinner());
  }
}

// Watchers

export function* watchSubmitToBeInTouch() {
  yield takeLatest(SUBMIT_TO_BE_IN_TOUCH, submitToBeInTouchTask);
}

export function* watchConfirm() {
  yield takeLatest(CONFIRM, confirmTask);
}

// Root saga

export default function* changingPricingPlanSaga() {
  yield all([watchSubmitToBeInTouch(), watchConfirm()]);
}
